var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconColorPicker = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0435 3.05882C19.6315 1.64706 17.3959 1.64706 16.1016 3.05882L13.6307 5.52941L12.3364 4.23529C12.101 4 11.748 4 11.5127 4.23529L9.74774 6C9.51241 6.23529 9.51241 6.58824 9.74774 6.82353L11.042 8.11765L3.15855 16L2.09957 19.2941C1.6366 20.6828 2.86373 22 4.21753 22C5.4341 22 6.80827 21.3633 7.98278 21.0588L15.8663 13.1765L17.1606 14.4706C17.3959 14.7059 17.7489 14.7059 17.9842 14.4706L19.7492 12.7059C19.9845 12.4706 19.9845 12.1176 19.7492 11.8824L18.4549 10.5882L20.9258 8.11765C22.3378 6.70588 22.3378 4.47059 21.0435 3.05882ZM6.80614 18.9412L4.57052 19.5294L5.15884 17.2941L12.5717 9.88235L14.219 11.5294L6.80614 18.9412Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconColorPicker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconColorPicker.b52d782e8d86630cd10d7b485a946942.svg";